import type { SVGProps } from 'react'
const SvgSyDell = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={9} fillOpacity={0.24} />
		<path d="m14.576 8.576-6 6 .848.848 6-6z" />
		<path d="m9.424 8.576-.848.848 6 6 .848-.848z" />
	</svg>
)
export default SvgSyDell
